export default __webpack_public_path__ + "static/media/logo.40d84c10.jpg";